/* ============================================
   Pouches Direct V2 — Password page
   Access-code overlay, cursor spotlight, countdown.
   ============================================ */
(function () {
  'use strict';

  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---- Access-code overlay ---------------------------------- */
  var lock = document.getElementById('pd-lock');

  if (lock) {
    var openLock = function () {
      if (lock.open) return;
      if (typeof lock.showModal === 'function') {
        lock.showModal();
      } else {
        lock.setAttribute('open', '');
      }
      var input = lock.querySelector('input[type="password"]');
      if (input) input.focus();
    };

    var closeLock = function () {
      if (typeof lock.close === 'function') {
        lock.close();
      } else {
        lock.removeAttribute('open');
      }
    };

    document.querySelectorAll('[data-pw-open]').forEach(function (trigger) {
      trigger.addEventListener('click', function (event) {
        event.preventDefault();
        openLock();
      });
    });

    lock.querySelectorAll('[data-pw-close]').forEach(function (trigger) {
      trigger.addEventListener('click', closeLock);
    });

    // Click on the blurred area outside the card dismisses it.
    lock.addEventListener('click', function (event) {
      if (event.target === lock) closeLock();
    });

    // A wrong password reloads with the dialog already open — shake the card,
    // then clear the flag so it only fires once.
    var card = lock.querySelector('.pd-lock__card');
    if (card && card.hasAttribute('data-pw-wrong') && !reduced) {
      requestAnimationFrame(function () {
        card.classList.add('is-wrong');
      });
      card.addEventListener('animationend', function () {
        card.classList.remove('is-wrong');
      });
    }
  }

  /* ---- Cursor spotlight ------------------------------------- */
  var spot = document.querySelector('[data-pw-spot]');

  if (spot && !reduced && window.matchMedia('(pointer: fine)').matches) {
    var pending = false;
    var x = 0;
    var y = 0;

    window.addEventListener(
      'pointermove',
      function (event) {
        x = event.clientX;
        y = event.clientY;
        if (pending) return;
        pending = true;
        requestAnimationFrame(function () {
          spot.style.setProperty('--pw-mx', x + 'px');
          spot.style.setProperty('--pw-my', y + 'px');
          pending = false;
        });
      },
      { passive: true }
    );
  }

  /* ---- Launch countdown ------------------------------------- */
  var countdown = document.querySelector('[data-pw-countdown]');

  if (countdown) {
    var target = Date.parse(countdown.getAttribute('data-pw-target') || '');
    var fields = {
      days: countdown.querySelector('[data-pw-days]'),
      hours: countdown.querySelector('[data-pw-hours]'),
      minutes: countdown.querySelector('[data-pw-minutes]'),
      seconds: countdown.querySelector('[data-pw-seconds]'),
    };

    var pad = function (value) {
      return value < 10 ? '0' + value : String(value);
    };

    var tick = function () {
      var remaining = target - Date.now();

      if (!isFinite(target) || remaining <= 0) {
        countdown.hidden = true;
        return false;
      }

      var seconds = Math.floor(remaining / 1000);
      if (fields.days) fields.days.textContent = pad(Math.floor(seconds / 86400));
      if (fields.hours) fields.hours.textContent = pad(Math.floor((seconds % 86400) / 3600));
      if (fields.minutes) fields.minutes.textContent = pad(Math.floor((seconds % 3600) / 60));
      if (fields.seconds) fields.seconds.textContent = pad(seconds % 60);
      return true;
    };

    if (tick()) {
      countdown.hidden = false;
      var timer = setInterval(function () {
        if (!tick()) clearInterval(timer);
      }, 1000);
    }
  }
})();
